export const MAX_LOOP_QUANTITY = 600;
export const LOOP_INTERVAL = 3 * 1000;
export const BASE_CREDIT_CONSUME = 2;
export const FACE_CREDIT_CONSUME = 1;
export const SCENE_ID = "017";
export const PROJECT_TYPE = "ai_face_swap";
export const NAV_POSITION = "swap_nav";
export const TYPE_LIMIT = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "image/heic",
  "image/heif",
];
export const TYPE_LIMIT_ACCEPT = TYPE_LIMIT.map(
  (item) => "." + item.split("/")[1]
).join(",");
export const VIDEO_TYPE_LIMIT = [
  "video/mp4",   // MP4 视频
  "video/m4v",   // M4V 视频
  "video/webm",  // WebM 视频
  "video/quicktime", // MOV 视频 (QuickTime)
  "video/x-msvideo"  // AVI 视频
];
export const VIDEO_TYPE_LIMIT_ACCEPT = ".mp4,.m4v,.webm,.mov,.avi"
export const MIN_CONFIDENCE = 0.5;
export const INPUT_SIZE = 416;
export const SCORE_THRESHOLD = 0.5;
export const FACE_LIMIT = 5;



export enum APICode {
  Success = "000",
  NotLogin = "114",
}

export enum TaskStatus {
  Generating = 4,
  Success = 1,
  Failed = 2,
  Timeout = 3,
  Waiting = 0,
  FeTimeout = 5, // 前端超时
}

export enum CollectStatus {
  UnCollect = 0,
  Collected = 1,
}

export enum FaceDetectRes {
  NoFace = "NoFace",
  TooManyFace = "TooManyFace",
  Success = "Success",
  TooSmall = "TooSmall",
  TooBig = "TooBig",
  Unknown = "Unknown",
}

export enum FTSwapAnalyzeObj {
  upload = "upload",
  history = "history",
  open_image = "open_image",
  add_image = "add_image",
  drag = "drag",
  next = "next",
  generate = "generate",
  step1 = "step1",
  step2 = "step2",
  other = "other",
  man = "man",
  woman = "woman",
  not_enough = "not_enough",
  no_login = "no_login",
  no_paid = "no_paid",
  cover_download = "cover_download",
  multi_download = "multi_download",
  details_download = "details_download",
  history_detail = "history_detail",
  professional = "professional",
  creativity = "creativity",
  edit = "edit",
  mylist = "mylist",
  create = "create",
  landing = "landing",
  mycreation = "my creation",
  sample = "sample",
  change = "change",
  face = "face",
  format = "format",
  smallsize = "smallsize",
  bigface = "bigface",
  manyfaces = "manyfaces",
  smallface = "smallface",
  noface = "noface",
  startswap = "startswap",
  compare = "compare",
  mylist_larger = "mylist_larger",
  nocredits = "nocredits",
  nologin = "nologin",
  fail = "fail",
  getcredits = "getcredits",
  no_credits = "no_credits",
  down_fail = "down_fail",
  templates = "templates",
  share = "share",
  Switch_packets = "Switch_packets",
}

export const I18nLangMap: any = {
  de: "de_DE",
  en: "en_US",
  es: "es_ES",
  fr: "fr_FR",
  jp: "ja_JP",
  pt: "pt_BR",
  ru: "ru_RU",
  cn: "zh_CN",
  tw: "zh_TW",
  id: "id_ID",
  it: "it_IT",
  th: "th_TH",
  vi: "vi_VN",
  tr: "tr_TR",
  pl: "pl_PL",
  nl: "nl_NL",
  ko: "ko_KR",
};

export const LocalStorageKey = {
  deviceId: "fotor_device_id",
  removeTipShowTimes: "fotor_face_swap_remove_tip_show_times",
  userInfo: "fotor_common_user_Info",
  adData: "fotor_common_advertise_data",
  /** 侧边栏，new */
  sidebarNewVideo: "fotor_face_swap_sidebar_new_video",
  /** 首次生产全部视频提示 */
  firstGenerateFullVideo: "fotor_face_swap_first_generate_full_video",
};

export enum TagType {
  NEW = "new",
  HOT = "hot",
}

export const SINGLE_TEMP_WIDTH = 3;
export const SINGLE_TEMP_HEIGHT = 4;

export const MULTI_TEMP_WIDTH = 4;
export const MULTI_TEMP_HEIGHT = 3;

export const MOBILE_THUMBNAIL_WIDTH = 384;
export const PC_THUMBNAIL_HEIGHT = 256;

export const HEADER_RESIDENT_ID = "face-swap-resident-ad";